<script setup>

// Imports
import { defineLazyHydrationComponent } from '#imports'

// Props
const props = defineProps({
  block: {
    type: Object,
    default: () => ({})
  }
})

const LazyCtaContained = defineLazyHydrationComponent(
  'visible',
  () => import('./ctaContainedInteractive.vue')
)

</script>

<!-- -------------------------------------------------------------------------------------------------
    Template
------------------------------------------------------------------------------------------------- -->

<template>
<LazyCtaContained
  :block="block"
  data-hydration="lazy-hydration"
/>
</template>
